import { createAction } from '@reduxjs/toolkit'

export const userExamsFetchDataSuccess = createAction<{ totalCount: number }>('USER_EXAMS_FETCH_DATA_SUCCESS')

export const userExamsUpdateSearchCondition = createAction<{ page: number }>('USER_EXAMS_UPDATE_SEARCH_CONDITION')
